import { Stack } from "expo-router";

/**
 * A vendor's public pages: the shop at the root and a table they are operating beneath it
 * (TRO-1187, ADR-0138).
 *
 * Mirrors `browse/_layout.tsx` — headerless, so each screen owns its whole viewport — and stays
 * mounted from the shop through the table to a card, so crossing between them keeps push and back
 * navigation instead of remounting the storefront.
 */
export default function ShopLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
